"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const typography_1 = require("../styles/typography");
const colors_1 = require("../styles/colors");
const ContentEditable_1 = require("../components/ContentEditable");
const PlaceholderComponent_1 = require("../components/PlaceholderComponent");
const Text = ({ contentEditable, handleBlurChange, handleChange, id, label, onBlurChange, onInputChange, placeholder, placeholderText, position, size, text, textStyle, inputType, }) => {
    let style = Object.assign({}, typography_1.text, typography_1.regular, { color: colors_1.charcoal, display: 'inline-block', lineHeight: '24px' });
    switch (size) {
        case 'h1':
            style = Object.assign({}, style, typography_1.semibold, { lineHeight: '40px', fontSize: 32 });
            break;
        case 'h2':
            style = Object.assign({}, style, typography_1.semibold, { lineHeight: '32px', fontSize: 25 });
            break;
        case 'x-large':
            style = Object.assign({}, style, typography_1.light, { color: colors_1.graphite, lineHeight: '80px', fontSize: 64 });
            break;
        case 'large':
            style = Object.assign({}, style, { fontSize: 19 });
            break;
        case 'medium':
            style = Object.assign({}, style, { fontSize: 17 });
            break;
        case 'small':
            style = Object.assign({}, style, { fontSize: 15 });
            break;
        case 'x-small':
            style = Object.assign({}, style, { fontSize: 13 });
            break;
    }
    if (position === 'center') {
        style = Object.assign({}, style, { textAlign: 'center' });
    }
    if (label === true) {
        style = Object.assign({}, style, { color: colors_1.graphite });
    }
    style = Object.assign({}, style, textStyle);
    const html = `${text}`;
    if (!contentEditable && (!placeholder || (placeholder && text.length !== 0))) {
        return React.createElement("div", { style: style }, text);
    }
    else if (!placeholder || (placeholder && text.length !== 0)) {
        return (React.createElement(ContentEditable_1.default, { handleBlurChange: handleBlurChange, html: html, id: id, onBlurChange: onBlurChange, onChange: handleChange, onInputChange: onInputChange, style: style, inputType: inputType }));
    }
    else {
        return (React.createElement(PlaceholderComponent_1.default, { contentEditable: contentEditable, handleBlurChange: handleBlurChange, html: html, id: id, onBlurChange: onBlurChange, onChange: handleChange, onInputChange: onInputChange, placeholderText: placeholderText, style: style, inputType: inputType }));
    }
};
Text.defaultProps = {
    text: '',
    size: 'medium',
    position: 'left',
    placeholder: false,
    contentEditable: false,
    handleChange: () => null,
    label: false,
    onBlurChange: false,
};
exports.default = Text;
